import { render, staticRenderFns } from "./customerInfoModal.vue?vue&type=template&id=3678e318&scoped=true"
import script from "./customerInfoModal.vue?vue&type=script&lang=js"
export * from "./customerInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3678e318",
  null
  
)

export default component.exports